<template>
  <div class="wrapper-full nibut">
    <el-container>
      <el-main>
        <div class="wrapper-full" style="display: flex; padding-left: 5px; padding-right: 5px">
          <div style="width: 50%; height: 100%">
            <VideoPlayer
              :dispW="dispW / 2 + 500"
              :dispH="height - 300 + 120"
              :src="originSrc"
              :realTotalTime="-1"
              :videoId="'dryeyeVideoOne'"
            />
          </div>
          <div style="width: 50%; height: 100%; position: relative">
            <div class="lipidlayer-txt">{{ $t("langcfg.txtReferenceLevel") }} {{ level }}</div>
            <VideoPlayer
              :dispW="dispW / 2 + 500"
              :dispH="height - 300 + 120"
              :src="videoSrc"
              :realTotalTime="10"
              :videoId="'dryeyeVideoTwo'"
            />
          </div>
        </div>
      </el-main>
      <el-footer height="150px">
        <table class="table-full" style="margin-top: 20px">
          <tbody class="table-full">
            <tr class="table-full">
              <td align="center" class="td-level" :style="`color:${lipidLevels[level - 1].color}`">
                Level: {{ level }}
              </td>
              <td class="table-height-full">
                <div
                  style="
                    display: flex;
                    height: 200px;
                    justify-content: space-around;
                    align-items: top;
                  "
                >
                  <!-- <ImageItem
                    v-for="(item, index) in lipidLevels"
                    :key="index"
                    :dispH="150"
                    :imagename="myimagename[item.level - 1]"
                    :imagenameStyle="imagenameStyle"
                    :src="videoImgSrc"
                    :namebackground="item.color"
                    :namecolor="'black'"
                    :id="index"
                    :currentid="currentId"
                    @select="selectItem"
                    style="width: auto; height: 100%; width: 224px"
                  /> -->
                  <div @click="selectItem(0)" :class="border1">
                    <div class="img-item" :style="`height:${dispH - 30}px;`">
                      <img
                        alt=""
                        :src="lipidImgList[0]"
                        style="width: auto; height: 100%; max-height: 100%"
                      />
                    </div>
                    <div
                      class="img-name0 img-name1"
                      :style="`background:'#e43d45';color:'#000';${imagenameStyle}`"
                    >
                      {{ $t("langcfg.txtFatlayer0") }}
                    </div>
                  </div>
                  <div @click="selectItem(1)" :class="border2">
                    <div class="img-item" :style="`height:${dispH - 30}px;`">
                      <img
                        alt=""
                        :src="lipidImgList[1]"
                        style="width: auto; height: 100%; max-height: 100%"
                      />
                    </div>
                    <div
                      class="img-name0 img-name2"
                      :style="`background:'#dd696f';color:'#000';${imagenameStyle}`"
                    >
                      {{ $t("langcfg.txtFatlayer1") }}
                    </div>
                  </div>
                  <div @click="selectItem(2)" :class="border3">
                    <div class="img-item" :style="`height:${dispH - 30}px;`">
                      <img
                        alt=""
                        :src="lipidImgList[2]"
                        style="width: auto; height: 100%; max-height: 100%"
                      />
                    </div>
                    <div
                      class="img-name0 img-name3"
                      :style="`background:'#f5a963';color:'#000';${imagenameStyle}`"
                    >
                      {{ $t("langcfg.txtFatlayer2") }}
                    </div>
                  </div>
                  <div @click="selectItem(3)" :class="border4">
                    <div class="img-item" :style="`height:${dispH - 30}px;`">
                      <img
                        alt=""
                        :src="lipidImgList[3]"
                        style="width: auto; height: 100%; max-height: 100%"
                      />
                    </div>
                    <div
                      class="img-name0 img-name4"
                      :style="`background:'#b5e07b';color:'#000';${imagenameStyle}`"
                    >
                      {{ $t("langcfg.txtFatlayer3") }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
import { Size, SubPageSize } from "../../mixins";
import { LIPIDLEVELS } from "../js/consts";
import VideoPlayer from "./basic/VideoPlayer";
import ImageItem from "./basic/ImageItem";
import EVENTS from "../../bus";
import fileSys from "../../fileoprators/fileSystem";
import { objectCopy, getImageUrl } from "../../shared/utils";
import { mapState } from "vuex";
import home from "../../store/modules/home";
const { ipcRenderer } = window.require("electron");
export default {
  name: "LipidLayer",
  mixins: [Size, SubPageSize],
  data() {
    return {
      zoom: 1.5,
      src: "",
      autoMeasureValue: "--",
      manualMeasureValue: "--",
      square: "--",
      isHugeMapVisible: false,
      currentId: 6,
      lipidLevels: LIPIDLEVELS,
      level: 4,
      myimagename: [],
      originSrc: "",
      videoSrc: "",
      videoImgSrc: "",
      mycurrentrecord: {},
      imagenameStyle: "height:53px;font-size: 24px;color: white;",
      lipidImgList: [],
      firstState: true
    };
  },
  watch: {
    currentEye(newType) {
      this.currentEye = newType;
      this.ifOS(this.record);
      this.selectItem(`${this.level}` - 1);
    },
    record: {
      handler(newRecord) {
        this.ifOS(newRecord);
      },
      immediate: true,
      deep: true
    }
  },
  props: {
    record: Object,
    currentEye: {
      type: String,
      default: "OS"
    }
  },
  mounted() {
    this.ifOS(this.record);
    this.selectItem(`${this.level}` - 1);

    this.watchSetStatus();
    const sendLipid = JSON.parse(localStorage.getItem("sendLipid"));
    if (sendLipid) {
      this.setFun(sendLipid.id);
    }
    this.lipidImgList = [
      `${fileSys.getCfgPath("img")}/lipid-1.jpg`,
      `${fileSys.getCfgPath("img")}/lipid-2.jpg`,
      `${fileSys.getCfgPath("img")}/lipid-3.jpg`,
      `${fileSys.getCfgPath("img")}/lipid-4.jpg`
    ];

    this.$bus.$emit(EVENTS.uploadingThirdyParty, "lipidlayer");
  },
  beforeDestroy() {
    this.$bus.$off(EVENTS.setLipid);
  },
  components: {
    VideoPlayer,
    ImageItem
  },
  computed: {
    ...mapState({
      isHasUrl: (state) => home.state.isHasUrl
    }),
    border1() {
      if (this.level === 1) {
        return "img-border-green";
      }
    },
    border2() {
      if (this.level === 2) {
        return "img-border-green";
      }
    },
    border3() {
      if (this.level === 3) {
        return "img-border-green";
      }
    },
    border4() {
      if (this.level === 4) {
        return "img-border-green";
      }
    }
  },
  methods: {
    ifOS(record) {
      this.mycurrentrecord = objectCopy(record);

      const { lipidlayer } = this.mycurrentrecord.content[`data${this.currentEye}`];
      const filename = lipidlayer.photos[0].filename;
      if (this.record.content[`data${this.currentEye}`]["lipidlayer"].level) {
        this.level = this.record.content[`data${this.currentEye}`]["lipidlayer"].level;
      } else {
        this.level = 4;
      }

      this.videoSrc = this.getVideoSrc(this.level);
      this.videoImgSrc = `${fileSys.getCfgPath("img")}/lipid-${this.level}.jpg`;
      this.originSrc = this.getImageURL(filename);
    },
    getVideoSrc(val) {
      return `${fileSys.getCfgPath("img")}/lipid-${val}.mp4`;
    },
    selectItem(id) {
      this.currentId = id;
      this.level = LIPIDLEVELS[id].level;

      this.videoSrc = this.getVideoSrc(this.level);

      this.mycurrentrecord.content[`data${this.currentEye}`]["lipidlayer"].level = this.level;
      if (
        this.record.content[`data${this.currentEye}`]["lipidlayer"].uploaded &&
        !this.firstState
      ) {
        this.mycurrentrecord.content[`data${this.currentEye}`]["lipidlayer"].uploaded = true;
        this.$bus.$emit(EVENTS.uploadingThirdyParty, "lipidlayer", this.mycurrentrecord, true);
      }
      this.firstState = false;
      this.$bus.$emit(EVENTS.updateData, this.mycurrentrecord, "", "", () => {});
      this.sendChangeStatus(id);
    },
    showHugeMap() {
      this.isHugeMapVisible = !this.isHugeMapVisible;
    },
    getImageURL(filename) {
      return getImageUrl(filename, window.server, window.token);
    },
    // 发送 改 同步
    sendChangeStatus(id) {
      let send = null;
      if (this.isHasUrl) {
        send = "sendSetMsg2";
      } else {
        send = "sendSetMsg";
      }
      ipcRenderer.send(send, {
        type: "sendLipid",
        id: id
      });
    },
    // 111监听修改
    watchSetStatus() {
      let _this = this;
      this.$bus.$on(EVENTS.setLipid, function (msg) {
        _this.currentId = msg.id;
        _this.level = LIPIDLEVELS[msg.id].level;
        _this.videoSrc = _this.getVideoSrc(_this.level);
        _this.mycurrentrecord.content[`data${_this.currentEye}`]["lipidlayer"].level = _this.level;
        _this.$bus.$emit(EVENTS.updateData, _this.mycurrentrecord, "", "", () => {});
      });
    },
    setFun(id) {
      this.currentId = id;
      this.level = LIPIDLEVELS[id].level;
      this.videoSrc = this.getVideoSrc(this.level);
      this.mycurrentrecord.content[`data${this.currentEye}`]["lipidlayer"].level = this.level;
      this.$bus.$emit(EVENTS.updateData, this.mycurrentrecord, "", "", () => {});
      localStorage.removeItem("sendLipid");
    }
  },
  created() {
    this.myimagename[0] = this.$t("langcfg.txtFatlayer0");
    this.myimagename[1] = this.$t("langcfg.txtFatlayer1");
    this.myimagename[2] = this.$t("langcfg.txtFatlayer2");
    this.myimagename[3] = this.$t("langcfg.txtFatlayer3");
  }
};
</script>
<style lang="less" scoped>
.border-top {
  border-top: solid rgba(gray, 0.1) 1px;
}
.nibut {
  position: relative;
}
.td-level {
  width: 600px;
  font-size: 50px;
  color: #00ff00;
}
.table-height-full /deep/ .img-item {
  width: 224px !important;
  height: 144px !important;
}
.table-height-full /deep/ img {
  width: 224px !important;
}
.table-height-full /deep/ .wrapper-full {
  border-radius: 10px;
}
.img-border-green {
  border: solid 3px #00ff00;
}
.img-border-gray {
  border: solid 1px gray;
}
.img-container {
  display: flex;
  flex-direction: column;
}
.img-name0 {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // background: #333333;
}
.img-name1 {
  background: #e43d45;
}
.img-name2 {
  background: #dd696f;
}
.img-name3 {
  background: #f5a963;
}
.img-name4 {
  background: #b5e07b;
}
.img-item {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  user-select: none;
  -webkit-user-drag: none;
}
.lipidlayer-txt {
  position: absolute;
  top: 10px;
  left: 6px;
  z-index: 1;
  background-color: rgba(204, 204, 204, 0.336);
  color: #409eff;
  padding: 0 10px;
  height: 30px;
  line-height: 30px;
  font-size: 25px;
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/dryeye/components/LipidLayer.vue